/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { exportAcceptedBidsCsv } from '../fn/csv-export/export-accepted-bids-csv';
import { ExportAcceptedBidsCsv$Params } from '../fn/csv-export/export-accepted-bids-csv';
import { exportPrebidsCsv } from '../fn/csv-export/export-prebids-csv';
import { ExportPrebidsCsv$Params } from '../fn/csv-export/export-prebids-csv';

@Injectable({ providedIn: 'root' })
export class GeneratedCsvExportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `exportPrebidsCsv()` */
  static readonly ExportPrebidsCsvPath = '/api/csv-export/prebids';

  /**
   * Exports a list of prebids for a given auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportPrebidsCsv()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  exportPrebidsCsv$Response(params: ExportPrebidsCsv$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportPrebidsCsv(this.http, this.rootUrl, params, context);
  }

  /**
   * Exports a list of prebids for a given auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportPrebidsCsv$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  exportPrebidsCsv(params: ExportPrebidsCsv$Params, context?: HttpContext): Observable<Blob> {
    return this.exportPrebidsCsv$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `exportAcceptedBidsCsv()` */
  static readonly ExportAcceptedBidsCsvPath = '/api/csv-export/accepted-bids';

  /**
   * Exports a list of accepted bids for a given auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportAcceptedBidsCsv()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  exportAcceptedBidsCsv$Response(params: ExportAcceptedBidsCsv$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return exportAcceptedBidsCsv(this.http, this.rootUrl, params, context);
  }

  /**
   * Exports a list of accepted bids for a given auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportAcceptedBidsCsv$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  exportAcceptedBidsCsv(params: ExportAcceptedBidsCsv$Params, context?: HttpContext): Observable<Blob> {
    return this.exportAcceptedBidsCsv$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
